import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import BusinessIcon from "@mui/icons-material/Business";
import Avatar from "@mui/material/Avatar";
import { Link, Outlet, useNavigate } from "react-router-dom";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import Cookies from "js-cookie";
import BasicModal from "../../pages/auth/login/loginModal";
import "./layout.css";
import PopperMenu from "./menuModal";
import { GroupSelect } from "../../components/common/dropDown/groupSelect";
import { useSelector, useDispatch } from "react-redux";
import { userSelector } from "../../redux/slices/userSlice";
import {
  fetchAllConversationSearchAPI,
  fetchFilterGroupAPI,
  userDetailsApi,
} from "../../redux/action/UserAction";
import { authSelector } from "../../redux/slices/authSlice";
import image from "../../assest/image/loggoo.png";

function Layout() {
  // Redux state selection
  const { userProfileData, searchValue, filterGrpData, startDate, endDate } =
    useSelector(userSelector);
  const { singInLoading } = useSelector(authSelector);

  // Local state
  const [isLoginOpen, setIsLoginOpen] = React.useState(false);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [grpName, setGrpName] = React.useState(
    sessionStorage.getItem("currentGrpName")
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Show login modal if token not present
  React.useEffect(() => {
    const token = Cookies.get("accessToken");
    if (!token) {
      setIsLoginOpen(true);
    }
  }, []);

  // Fetch groups and user details on login
  React.useEffect(() => {
    dispatch(fetchFilterGroupAPI());
    dispatch(userDetailsApi());
  }, [singInLoading]);

  // Set default group from API if not stored
  React.useEffect(() => {
    const stored = sessionStorage.getItem("currentGrpName");
    if (!stored && filterGrpData?.[0]?.name) {
      sessionStorage.setItem("currentGrpName", filterGrpData[0]?.name);
      setGrpName(filterGrpData[0].name);
    }
  

  }, [filterGrpData]);

  // Handle user menu (avatar) toggle
  const handleOpenUserMenu = (event) => {
    setMenuOpen(!menuOpen);
  };

  // Handle group selection change
  const handleChange = (event) => {
    const selectedId = event.target.value;
    sessionStorage.setItem("currentGrp", selectedId);
    const selectedOption = userProfileData?.groups?.find(
      (opt) => opt?.id === selectedId
    );
    sessionStorage.setItem("currentGrpName", selectedOption?.name);
    
    setGrpName(selectedOption?.name);

    // Fetch data again based on new group
    dispatch(
      fetchAllConversationSearchAPI(null, searchValue, startDate, endDate)
    );
    sessionStorage.setItem("userType", selectedOption?.user_type);
    navigate("/");
  };

  // Prevent default ESC key behavior (optional feature)
  React.useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        console.log("Escape key blocked");
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    // Cleanup
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <>
      <div className="page-wrapper">
        {/* Top AppBar */}
        <div className="appbar-wrapper">
          <AppBar
            position="static"
            elevation={1}
            sx={{ backgroundColor: "white", color: "black" }}
          >
            <Toolbar
              disableGutters
              sx={{
                display: "flex",
                justifyContent: "space-between",
                margin: "0px 15px",
                // color: "yellow",
              }}
            >
              {/* Logo linking to home */}
              <Link
                to={"/"}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <img
                  style={{ height: "70px", width: "100px" }}
                  src={image}
                  alt="logo"
                />
              </Link>

              {/* Organization and user controls */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{ display: "flex", gap: "5px", marginRight: "30px" }}
                >
                  <BusinessIcon />
                  <p>{userProfileData?.organization ?? "Organization"}</p>
                </div>

                <Box
                  sx={{
                    flexGrow: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: "15px",
                  }}
                >
                  {/* Group selector dropdown */}
                  <GroupSelect
                    options={userProfileData?.groups}
                    val={grpName}
                    labelText={"Select Group"}
                    labelIcon={<PeopleOutlineOutlinedIcon />}
                    handlechange={handleChange}
                    isDisabled={
                      userProfileData?.groups?.length > 1 ? false : true
                    }
                  />

                  {/* Avatar and menu */}
                  <IconButton
                    onClick={handleOpenUserMenu}
                    sx={{ p: 0, position: "relative" }}
                  >
                    <Avatar
                      alt="Remy Sharp"
                      src={userProfileData?.profile_pic}
                      sx={{ width: "45px", height: "45px" }}
                    />
                    <PopperMenu menuOpen={menuOpen} setMenuOpen={setMenuOpen} />
                  </IconButton>
                </Box>
              </div>
            </Toolbar>
          </AppBar>
        </div>

        {/* Page content area */}
        <div className="outlet-wrapper">
          <Outlet />
        </div>
      </div>

      {/* Login modal shown if token not present */}
      <BasicModal open={isLoginOpen} setOpen={setIsLoginOpen} />
    </>
  );
}

export default Layout;
